import { toast, Flip } from "react-toastify";
import { deleteEmployee, addEmployee } from "../services/userService";
import { UserContent } from "../edit-user/component/types";
import { enrichUsersData } from "src/shared/utils/userUtils";

export const update = (
  customerdata: any,
  setloading: Function,
  onSuccess?: Function,
) => {
  setloading(true);
  return addEmployee(customerdata)
    .then(() => {
      setloading(false);
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch((error: any) => {
      console.error("Error during user upload:", error);
      setloading(false);
      const message = error.response?.data?.message;
      if (message === "Email Already Exists") {
        toast.error("Email already exists");
      } else if (message === "Username Already Exist") {
        toast.error("Username already exists");
      } else {
        toast.error("An error occurred");
      }
      throw error;
    });
};

export const deleteUser = (id: string | number, setTempId: Function, setEmployeedata: Function, setFilteredData: Function) => {
  deleteEmployee(id)
    .then(() => {
      setTempId("");
      setEmployeedata((prevData: any[]) => prevData.filter((item) => item._id.$oid !== id));
      setFilteredData((prevData: any[]) => prevData.filter((item) => item._id.$oid !== id));
    })
    .catch((error) => {
      console.error("Error deleting user:", error);
      toast.error("Failed to delete user", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Flip,
      });
    });
};

export const filters = (value: boolean, api: any, setfear: Function, setEmployeedata: Function, setFilteredData: Function) => {
  if (value === true) {
    api
      .get(`/pos/v2/add_employee/DeletedUsers`)
      .then((res: any) => {
        const emergency: UserContent[] = res.data.result;
        setfear(emergency);
        if (res.data.message === "No deleted users found") {
          const err = res.data.message;
          toast(err);
        }
        const userData = res.data.result;
        if (userData) {
          // ✅ Use the enrichUsersData utility to ensure proper structure
          const enrichedData = enrichUsersData(userData);
          setEmployeedata(enrichedData);
          setFilteredData(enrichedData);
        }
      })
      .catch((error: any) => {
        const err = error.response?.data?.message || "An unknown error occurred";
        if (err === "Email Already Exists") {
          toast.error("Email Already Exists. Please try a different email.");
        } else {
          toast.error(err);
        }
      });
  } else {
    api.get(`/pos/v2/get_user`).then((res: any) => {
      const userData = res.data.result.filter((data: any) => data.userName !== null && data.userName !== undefined);
      
      // ✅ Use the enrichUsersData utility to ensure proper structure
      const enrichedData = enrichUsersData(userData);
      
      setEmployeedata(enrichedData);
      setFilteredData(enrichedData);
    });
  }
};